export default __webpack_public_path__ + "static/media/thirdPartyOtherRequest.f0ee8c6b.svg";